import gql from 'graphql-tag';

export const UPSERT_CREDIT_SUBMISSION_DECLINE_REASONS = gql`
  mutation UpsertCreditSubmissionDeclineReasons($input: [UpsertCreditSubmissionDeclineReasonsInput]!) {
    upsertCreditSubmissionDeclineReasons(input: $input)
  }
`;
